import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import type { PostConversationalPreviewSettingsProps, PostConversationalPreviewSettingsResult } from "./types";

export const postConversationalPreviewSettings = reactQueryMutationAdapter(
  [],
  (props: PostConversationalPreviewSettingsProps): Promise<PostConversationalPreviewSettingsResult> => {
    return fetch(`/${props.appGroupId}/conversational/preview_settings`, "POST", {
      session_id: props.sessionId,
      user_message: props.userMessage,
      conversational_setting: props.conversationalSetting,
    });
  }
);
